import { DIMBO_CONSTANT } from './../utils/constant';
import { CacheService } from './cache.service';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class SetTokenInterceptorService implements HttpInterceptor {

    constructor( private cacheService: CacheService) {

    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const jwt_token = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_TOKEN);
        request = request.clone({
            setHeaders: {
                //authorizationToken: `Bearer ${jwt_token}`,
                authorizationToken: `Bearer ${jwt_token}`,
                'Content-Type': 'application/json'
            }
        });
      
        return next.handle(request);
    }
}


/* provider: [{
provide: HTTP_INTERCEPTORS,
useClass: SetWithCredentialsHeaderInterceptor, multi: true
} ] */
 
